import { Configuration, LogLevel } from '@azure/msal-browser';
import { env } from './env';

/**
 * MSAL-Konfiguration für die Anmeldung der Endnutzer an Entra ID.
 * Achtung: Diese App fordert NUR ein Token für die eigene API an
 * (Scope = exposed API scope). Privilegierte Graph-Operationen laufen
 * ausschließlich App-Only im Backend.
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: env.spaClientId,
    authority: `https://login.microsoftonline.com/${env.tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    // Auth-State zusätzlich im Cookie ablegen — hilft, wenn Drittanbieter-Cookies
    // die stille Iframe-Erneuerung stören.
    storeAuthStateInCookie: true,
  },
  system: {
    // Stille Token-Erneuerung läuft über ein verstecktes Iframe; die Standard-
    // Timeouts (6 s) laufen bei langsamer Anmeldung/Netzwerk schnell ab
    // ("monitor_window_timeout"). Etwas großzügiger ansetzen.
    iframeHashTimeout: 12000,
    windowHashTimeout: 12000,
    loadFrameTimeout: 12000,
    loggerOptions: {
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
      loggerCallback: () => {
        /* in Produktion an Telemetrie anbinden */
      },
    },
  },
};

export const loginRequest = {
  scopes: [env.apiScope],
};
